import { useEffect, useState } from "react";

/**
 * Compte à rebours en secondes, remis à zéro quand `seconds` change. Sert au
 * délai de `Retry-After` : le bouton reste inactif tant qu'il court.
 */
export function useCountdown(seconds: number | undefined): number {
  const [restant, setRestant] = useState(seconds ?? 0);

  useEffect(() => {
    setRestant(seconds ?? 0);
    if (!seconds || seconds <= 0) {
      return;
    }
    const minuteur = setInterval(() => {
      setRestant((r) => (r <= 1 ? 0 : r - 1));
    }, 1000);
    return () => clearInterval(minuteur);
  }, [seconds]);

  return restant;
}
